module.exports = __webpack_public_path__ + "28b67065/img/search-filter-icon.c4751a52.svg";